const ProductList = {
  'pages_product_ProductList.1': '상품 목록',
  'pages_product_ProductList.column.headerName.all': '전체',
  'pages_product_ProductList.column.headerName.1': 'No.',
  'pages_product_ProductList.column.headerName.2': '구분(Level 1)',
  'pages_product_ProductList.column.headerName.3': '구분(Level 2)',
  'pages_product_ProductList.column.headerName.4': '상품카테고리',
  'pages_product_ProductList.column.headerName.5': '상품명',
  'pages_product_ProductList.column.headerName.6': '신규여부',
  'pages_product_ProductList.column.headerName.7': '상품 담당자',
  'pages_product_ProductList.column.headerName.8': '담당자 이메일',
  'pages_product_ProductList.column.headerName.9': '최종 수정일',
  'pages_product_ProductList.column.headerName.10': '활성화 상태',
  'pages_product_ProductList.column.headerName.11': '활성',
  'pages_product_ProductList.column.headerName.12': '비활성'
}

export default ProductList



// WEBPACK FOOTER //
// ./src/lang/product/ProductList.kr.js